export const TrackLinkConstants = {
    ANCHOR_TAG: 'a',
};
